<template>
  <div>
    <div id="videoWindow" class="video"></div>
  </div>
</template>

<script>
import Quagga from "quagga";

export default {
  name: 'Scanner',

  data: () => ({
  }),

  props: {
  },

  mounted() {
    Quagga.onDetected((data) => {
      const foundResult = data[0];
      const foundCode = {
        code: foundResult.codeResult.code,
        type: foundResult.codeResult.format
      };
      this.$emit("found", foundCode);
    });

    const config = {
        locate: true,
        inputStream: {
            name: "live",
            type: "LiveStream",
            constraints: {
                width: 200,
                facingMode: "environment"
            },
            target: document.querySelector("#videoWindow")
        },
        decoder: {
            readers: ["ean_reader"],
            multiple: true
        },
        locator: {
            halfSample: true,
            patchSize: "medium"
        }
    };
    Quagga.init(config, err => {
        if (err) {
            console.log(err);
            return;
        }
        Quagga.start();
    });
  },

  beforeDestroy() {
    Quagga.stop();
  },

  methods: {
  }
}
</script>

<style>
    .video {
        width: 100%;
        max-height: 200px;
        overflow: hidden;
    }
</style>
